import type { AppRuntime, Session } from "@ark/contracts";
import { ArkThemeProvider } from "@ark/ui/primitives";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import HomeApp from "./App";

const standaloneSession: Session = {
  identifier: "demo@ark-x.space",
  tenant: { id: "demo-tenant", name: "Ark 示例组织" },
  tenants: [{ id: "demo-tenant", name: "Ark 示例组织" }],
  token: {
    accessExpiresAt: "2099-01-01T00:00:00Z",
    accessToken: "standalone",
    refreshExpiresAt: "2099-01-01T00:00:00Z",
    refreshToken: "standalone",
  },
  user: {
    createdAt: "2026-01-01T00:00:00Z",
    displayName: "产品团队",
    email: "demo@ark-x.space",
    id: "demo-user",
    name: "Ark User",
    status: "active",
    updatedAt: "2026-01-01T00:00:00Z",
  },
};

const unavailable = <T,>(): Promise<T> =>
  Promise.reject(new Error("standalone mode has no API backend"));

const runtime: AppRuntime = {
  api: {
    delete: unavailable,
    get: unavailable,
    patch: unavailable,
    post: unavailable,
    put: unavailable,
    resolve: (path) => path,
  },
  getSession: () => standaloneSession,
  navigate: (to) => {
    console.info("standalone navigate", to);
  },
  subscribeSession: () => () => undefined,
};

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

createRoot(root).render(
  <StrictMode>
    <ArkThemeProvider>
      <HomeApp runtime={runtime} />
    </ArkThemeProvider>
  </StrictMode>,
);
